import {
  CONTRATO_STATUS_EM_EDICAO,
  CONTRATO_STATUS_EM_ANALISE,
  CONTRATO_STATUS_AGUARDANDO_ASSINATURA,
  CONTRATO_STATUS_NAO_INICIADO,
  CONTRATO_STATUS_VIGENTE,
  CONTRATO_STATUS_ENCERRADO,
  CONTRATO_STATUS_DESATIVADO,
  CONTRATO_STATUS_AGUARDANDO_EXTRATO,
  CONTRATO_STATUS_APROVADO,
  CONTRATO_STATUS_NEGADO,
} from '../../../library/ContratoStatus';

export const PUFVOperacionalPermissions = {
  id: 'pufv_operacional',

  navbar: {
    view: true,
    profile: {
      edit: false,
      perfilBeta: false,
    },
  },

  projetos: {
    list: false,
    register: false,
    edit: false,
    approve: false,
    reprove: false,
    editFinished: false,
    remove: false,
    viewChecker: {
      professorGestor: false,
      coordenadorLocal: false,
    },
    filters: {
      situacao: false,
      coop: false,
    },
  },

  reembolsos: {
    list: false,
    register: false,
    edit: false,
    remove: false,
  },

  professores: {
    list: false,
    register: false,
    edit: false,
    approve: false,
    reprove: false,
    activate: false,
    deactivate: false,
    canRemove: false,
  },

  assessores: {
    list: false,
    register: false,
    edit: false,
    activate: false,
    deactivate: false,
    canRemove: false,
  },

  coordenadores: {
    list: false,
    register: false,
    edit: false,
    activate: false,
    deactivate: false,
    canRemove: false,
  },

  empresas: {
    list: false,
    register: false,
    edit: false,
    remove: false,
  },

  escolas: {
    list: false,
    register: false,
    edit: false,
    activate: false,
    deactivate: false,
    dadosDaEscola: {
      list: false,
      register: false,
      edit: true,
      duplicate: false,
      remove: true,
    },
    ideb: {
      list: false,
      register: false,
      edit: false,
      remove: false,
    },
  },

  relatorios: {
    generate: {
      projetos: false,
      'dados-cadastrais': false,
      'dados-gerais': false,
      'dados-do-programa': false,
      assessoria: false,
      'dados-do-ideb': false,
      contratos: true,
      escolas: false,
    },
  },

  materiaisPedagogicos: {
    list: false,
    download: false,
  },

  agendaAssessoresPedagogicos: {
    list: false,
    register: false,
    edit: {
      locked: false,
      unlocked: false,
    },
    lock: false,
    unlock: false,
    remove: [false, false, false, false, false],
  },

  dashboard: {
    generate: false,
  },

  contratos: {
    list: true,
    editEvenWhenDisabled: true,
    assessor: {
      allStatus: [
        CONTRATO_STATUS_EM_EDICAO,
        CONTRATO_STATUS_EM_ANALISE,
        CONTRATO_STATUS_AGUARDANDO_ASSINATURA,
        CONTRATO_STATUS_NAO_INICIADO,
        CONTRATO_STATUS_VIGENTE,
        CONTRATO_STATUS_ENCERRADO,
        CONTRATO_STATUS_DESATIVADO,
      ],
      edit: true,
      register: true,
      view: true,
      upload: true,
      changeUpload: true,
      changeStatus: true,
      analiseOperacional: {
        edit: true,
      },
      templates: {
        list: true,
        edit: true,
      },
    },
    entePublico: {
      allStatus: [
        CONTRATO_STATUS_EM_EDICAO,
        CONTRATO_STATUS_EM_ANALISE,
        CONTRATO_STATUS_AGUARDANDO_ASSINATURA,
        CONTRATO_STATUS_NAO_INICIADO,
        CONTRATO_STATUS_VIGENTE,
        CONTRATO_STATUS_ENCERRADO,
        CONTRATO_STATUS_DESATIVADO,
        CONTRATO_STATUS_AGUARDANDO_EXTRATO,
        CONTRATO_STATUS_APROVADO,
        CONTRATO_STATUS_NEGADO,
      ],
      downloadChecklist: true,
      edit: true,
      register: true,
      view: true,
      uploadNaoAssinado: true,
      uploadAssinado: true,
      uploadExtrato: true,
      changeUploadAssinado: true,
      changeUploadExtrato: true,
      changeUploadPlanoTrabalho: true,
      changeStatus: true,
      analiseOperacional: {
        edit: true,
      },
    },
    entePrivado: {
      allStatus: [
        CONTRATO_STATUS_EM_EDICAO,
        CONTRATO_STATUS_EM_ANALISE,
        CONTRATO_STATUS_AGUARDANDO_ASSINATURA,
        CONTRATO_STATUS_NAO_INICIADO,
        CONTRATO_STATUS_VIGENTE,
        CONTRATO_STATUS_ENCERRADO,
        CONTRATO_STATUS_DESATIVADO,
      ],
      edit: true,
      register: true,
      view: true,
      upload: true,
      changeUpload: true,
      changeStatus: true,
      analiseOperacional: {
        edit: true,
      },
      templates: {
        list: true,
        edit: true,
      },
    },
  },
};
